var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutocompleteService',_vm._g(_vm._b({attrs:{"data-cy":"digitar-cest","display":_vm.display,"item-value":"codigo","service":_vm.service,"hide-selected":""}},'AutocompleteService',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }